import { useState, useEffect } from 'react'

export function useAddon(id) {
	// console.log("🚀 ~ file: useAddon.jsx:4 ~ useAddon ~ id:", id)
	const [data, setData] = useState(null)
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)


	useEffect(() => {
		async function fetchData() {
			setLoading(true)
			try {
				const response = await fetch(`${process.env.REACT_APP_BASE_API}order/apis/getAddonsSpecial.php?pid=${id}`)
				const data = await response.json()
				setData(data)
			} catch (error) {
				setError(error)
			} finally {
				setLoading(false)
			}
		}
		fetchData()
	}, [id])

	return { data, loading, error }
}
